<template>
    <div class="max-w-sm px-16">
        <ria-input 
            v-if="!show"
            name="email" 
            :label="$t('participants.email')" 
            validation="required|email" 
            type="email" 
            class="mb-8"
            value="" 
            ref="email" />
        <div v-if="show">
            {{ $t('auth.login.mail_password') }}
        </div>
        <ria-button v-if="!show" class="block mx-auto mt-4 text-base" :text="$t('auth.login.restore_password')" :action="restorePassword" />
    </div>
</template>

<script>
    import RiaButton from "@/components/common/ria-button"
    import RiaInput from "@/components/form/elements/ria-input";
    import { apiClient } from "@/api"; 

    export default {
        name: "restore-password",
        components : {
            RiaButton,
            RiaInput
        },
        data() {
            return {
                show: false
            };
        },
        methods: {
            restorePassword() {
                apiClient.restorePassword(this.$refs.email.value).then(() => {
                    this.show = true
                }).catch((error) => {
                    console.error(`Error logging in user to Firebase: ${error.message}`);
                })
            }
        }
    };
</script>

<style scoped>
    .password-forget {
        @apply mt-4.5 text-center;
    }

    .register {
        @apply  mt-2 text-center;
    }
</style>

